import PropTypes from 'prop-types';
import { useState } from 'react';

const SelectPopup = ({ message, onClose, callback, btnOkName, btnCancelName }) => {
    const handleOnClickOk = () => {
        if (callback) callback('ok');
        onClose();
    };

    const handleOnClickCancel = () => {
        if (callback) callback('cancel');
        onClose();
    };

    return (
        <div className="modal-container">
            <div>
                <div className="lay-pop lay-noti" style={{ display: 'block', borderRadius: '1rem' }}>
                    <div className="pop-bx">
                        <div className="pop-con">
                            <p style={{ whiteSpace: 'pre-line' }}>{message}</p>
                        </div>
                        <div className="pop-foot" style={{ justifyContent: 'center' }}>
                            <button
                                type="button"
                                onClick={handleOnClickOk}
                                style={{ paddingLeft: '4px', paddingRight: '4px', marginRight: '16px', fontWeight: '600' }}
                            >
                                {btnOkName}
                            </button>
                            <button
                                type="button"
                                onClick={handleOnClickCancel}
                                style={{ paddingLeft: '4px', paddingRight: '4px', marginLeft: '16px', fontWeight: '600' }}
                            >
                                {btnCancelName}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

function useSelectPopup() {
    const [popup, setPopup] = useState(null);

    const openPopup = (message, callback, btnOkName = '확인', btnCancelName = '취소') => {
        setPopup({ message, callback, btnOkName, btnCancelName });
        setTimeout(() => {
            $('#popSelect').fadeIn();
        }, 100);
    };

    const closePopup = () => {
        setPopup(null);
        $('#popSelect').fadeOut();
    };

    const PopupComponent = popup ? (
        <SelectPopup
            message={popup.message}
            onClose={closePopup}
            callback={popup.callback}
            btnOkName={popup.btnOkName}
            btnCancelName={popup.btnCancelName}
        />
    ) : null;

    return [openPopup, PopupComponent];
}

SelectPopup.propTypes = {
    message: PropTypes.string,
    btnOkName: PropTypes.string,
    btnCancelName: PropTypes.string,
    onClose: PropTypes.func,
    callback: PropTypes.func
};

export default useSelectPopup;
